module.exports = __webpack_public_path__ + "static/media/vc.ffdcc59c.svg";